import { useEffect } from 'react';
import { usePersonalization } from './usePersonalization';

export default function PageTracker({ pageTitle, category, keywords = [] }) {
  const { trackPageView } = usePersonalization();

  useEffect(() => {
    const url = window.location.pathname;
    trackPageView(pageTitle, url, category, keywords);
  }, [pageTitle, category]);

  return null;
}